import TableConstructor from "layout/TableConstructor";
import {
  Examination_Type,
  OrderType,
  PlatformVacancyCompanyCandidateListOrderFields,
  PlatformVacancyCompanyCandidateListOrderInput,
  useVacancyCompanyCandidatesQuery,
} from "@generated/graphql";
import { RouteEnum } from "layout/TableConstructor/types";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import ROUTES from "constants/routes";
import { Button, Tooltip } from "@mui/material";
import { getTestingPath } from "helpers/index";
import { CANDIDATE_IDS_QUERY_NAME } from "constants/global";
import qs from "qs";
import getColumnConfig from "./tableConfig/columnConfig";
import filterConfig from "./tableConfig/filterConfig";
import {
  VacancyCompanyCandidateFilter,
  VacancyCompanyCandidateItemWithAssessmentCV,
  VacancyCompanyCandidatesRefetch,
} from "../../types";

interface VacancyCandidateListProps {
  setVacancyCompanyCandidatesRefetch: React.Dispatch<React.SetStateAction<VacancyCompanyCandidatesRefetch | null>>;
}

const VacancyCandidateList = ({ setVacancyCompanyCandidatesRefetch }: VacancyCandidateListProps) => {
  const { vacancyId } = useParams();
  const navigate = useNavigate();
  const [selectedCandidates, setSelectedCandidates] = useState<string[]>([]);

  const order: PlatformVacancyCompanyCandidateListOrderInput = {
    field: PlatformVacancyCompanyCandidateListOrderFields.CompanyCandidateFullName,
    order: OrderType.Desc,
  };

  const permanentFilter = {
    vacancyId: vacancyId!,
  };

  const { data, loading, refetch } = useVacancyCompanyCandidatesQuery({
    variables: {
      page: 0,
      limit: 50,
      filter: permanentFilter,
      order,
    },
  });

  const vacancyCandidateList = data?.vacancyCompanyCandidates.data || [];
  const totalCount = data?.vacancyCompanyCandidates.totalCount;

  useEffect(() => {
    setVacancyCompanyCandidatesRefetch(() => () => refetch());
  }, [refetch]);

  const navigateToView = (id: string) => {
    navigate({ pathname: `/${ROUTES.CANDIDATE}/view/${id}`, search: qs.stringify({ vacancyId }) });
  };

  const renderControls = () => {
    const handleClick = () => {
      navigate({
        pathname: getTestingPath("examination"),
        search: qs.stringify({
          type: Examination_Type.Group,
          [CANDIDATE_IDS_QUERY_NAME]: selectedCandidates.join(","),
          vacancyId,
        }),
      });
    };

    const disabled = !selectedCandidates.length;

    return (
      <Tooltip title={disabled ? "Необходимо выбрать кандидатов" : ""}>
        <span>
          <Button
            onClick={handleClick}
            disabled={disabled}
            variant='contained'>
            Создать тестирование
          </Button>
        </span>
      </Tooltip>
    );
  };

  return (
    <TableConstructor<
      VacancyCompanyCandidateItemWithAssessmentCV,
      VacancyCompanyCandidateFilter,
      PlatformVacancyCompanyCandidateListOrderFields,
      undefined,
      RouteEnum.VacancyCandidate
    >
      exportRoute={RouteEnum.VacancyCandidate}
      settingsModalTitle='Список кандидатов вакансии'
      data={vacancyCandidateList}
      totalCount={totalCount}
      loading={loading}
      columnsConfig={getColumnConfig({
        setVacancyCompanyCandidatesRefetch: refetch,
        selectedCandidates,
        setSelectedCandidates,
      })}
      filtersConfig={filterConfig}
      emptyPlaceholderText='Пока нет кандидатов вакансии'
      // @ts-expect-error не получается затипизировать
      refetch={refetch}
      storageName='vacancyCandidateList'
      onRowClick={(row) => navigateToView(row.companyCandidate.id)}
      defaultOrder={order}
      permanentFilter={permanentFilter}
      renderControls={renderControls}
      defaultVisibleColumnList={[
        "checkbox",
        "numericId",
        "createdAt",
        "telegramUsername",
        "login",
        "fullName",
        "isCVFile",
        "cvCheckScore",
        "action",
      ]}
    />
  );
};

export default VacancyCandidateList;
